import { Component, OnInit, ViewChild } from '@angular/core';
import { ModalController, AlertController, IonTextarea } from '@ionic/angular';
import { CartService } from '../../services/cart.service';

@Component({
    selector: 'app-cart-additional-info',
    templateUrl: './cart-additional-info.page.html',
    styleUrls: ['./cart-additional-info.page.scss'],
})
export class CartAdditionalInfoPage implements OnInit {

    @ViewChild('special_instructions_input', { static: false }) special_instructions_input: IonTextarea;

    special_instructions = "";
    customer_note = "";
    internal_note = "";
    cart = null;

    constructor(
        public modalController: ModalController,
        public alertController: AlertController,
        private cartService: CartService

    ) { }

    ngOnInit() {

        this.cartService.get().then((cart) => {

            this.cart = cart;

            if(cart['special_instructions']) {
                this.special_instructions = cart['special_instructions'];
            }
            if(cart['customer_note']) {
                this.customer_note = cart['customer_note'];
            }
            if(cart['internal_note']) {
                this.internal_note = cart['internal_note'];
            }

        });

    }

    ionViewDidEnter() {
        // NOTE: we use a timeout here so the DOM gets a chance to load
        setTimeout(() => {
            if(this.special_instructions_input) {
                this.special_instructions_input.setFocus();
            }
        }, 200);
    }

    close() {
        this.modalController.dismiss();
    }

    async update() {

        if(this.special_instructions != this.cart['special_instructions']) {
            await this.cartService.updateSpecialInstructions(this.special_instructions).then(() => {}).catch(() => {});
        }
        if(this.customer_note != this.cart['customer_note']) {
            await this.cartService.updateCustomerNote(this.customer_note).then(() => {}).catch(() => {});
        }
        if(this.internal_note != this.cart['internal_note']) {
            await this.cartService.updateInternalNote(this.internal_note).then(() => {}).catch(() => {});
        }

        this.modalController.dismiss();

    }

    async presentAlert(header, sub_header, message) {
        const alert = await this.alertController.create({
            header: header,
            subHeader: sub_header,
            message: message,
            buttons: ['OK']
        });
        await alert.present();
    }

}
